const Header = () => <div id="navigationHeader" />;

export default Header;
